<div class="sidebar" role="dialog">

	<app-sidebar-header [title]="'extrasSidebar.airportTransfer.title.airportTransfer' | ibeadmin | async" [label]="'extrasSidebar.airportTransfer.label.discountVoucher' | ibeadmin | async">
		<div actions>
			<button class="button button--small" 
				*ngIf="INDRA_showHandleDone()"
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()"
				[attr.aria-label]="'extrasSidebar.airportTransfer.aria.confirmChanges' | ibeadmin | async">
				{{ 'extrasSidebar.airportTransfer.label.done' | ibeadmin | async }}
			</button>
		</div>
	</app-sidebar-header>

	<div class="block-stopover">
		<div class="grid">
			<div class="col-12 col-tp-12 col-p-12">
				<app-svg class="icon" svg="icons.svg#services--book_hotel" aria-hidden="true" [alt]="'extrasSidebar.airportTransfer.alt.partnerStopover' | ibeadmin | async">
				</app-svg>
				{{ 'extrasSidebar.airportTransfer.label.stopoverIn' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}
			</div>
		</div>
	</div>


	<div class="sidebar__body sl--scrollable" #sidebar__body style="height: calc(100% - 60px); overflow: auto">

		<div class="block-image" alt="">
			<img src="./assets/images/destinations/banner/transfer.jpg" alt="" />
		</div>

		<div #sidebar__info class="sidebar__info">
			<ul class="vantages-listing">
				<li>{{ 'extrasSidebar.airportTransfer.text.transferFrom' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} {{ 'extrasSidebar.airportTransfer.text.airportLocation' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.airportTransfer.text.transferFromALocation' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} {{ 'extrasSidebar.airportTransfer.text.airport' | ibeadmin | async }} </li>
				<li>{{ 'extrasSidebar.airportTransfer.text.chooseVehicle' | ibeadmin | async }}</li>
				<!-- <li>{{ 'extrasSidebar.airportTransfer.text.originalPrices' | ibeadmin | async }}</li> -->
				<li>{{ 'extrasSidebar.airportTransfer.text.enjoyDiscount' | ibeadmin | async }}</li>
			</ul>

			<a class="link link--external" 
				title="Open dialog for All about {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} Airport transfers" href="javascript:;"
				(click)="INDRA_gotoURL()">
				{{ 'extrasSidebar.airportTransfer.text.allAbout' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} {{ 'extrasSidebar.airportTransfer.text.airportTranfers' | ibeadmin | async }}
			</a>
		</div>

		<hr class="separator" aria-hidden="true">

		<div class="passenger">

			<div class="passenger__details">
				<h3 class="title-h3 passenger__name">
					{{ 'extrasSidebar.airportTransfer.text.allPassengers' | ibeadmin | async }}
				</h3>				
			</div>

			<div class="passenger__actions">
				<div class="passenger__action" *ngIf="form.get('vehicle').value">

					<span class="status_label">{{ 'extrasSidebar.airportTransfer.aria.transferAdded' | ibeadmin | async }}</span>
					<app-svg class="right check" svg="sprite.svg#flight--brand-checked" [attr.aria-label]="'extrasSidebar.airportTransfer.aria.transferAdded' | ibeadmin | async"
						alt='Added icon'></app-svg>

					<div class="button_close" [ngClass]="['remove-extra']" aria-label="Remove Ancillary" tabindex="0"
						(click)="INDRA_removeTransfer()">
						<app-svg svg="icons.svg#general--not_available" aria-hidden="true"
							[alt]="'Remove icon'"></app-svg>
					</div>
				</div>

				<div class="passenger__action" *ngIf="!form.get('vehicle').value">
					<button class="button button-main-line full-width" (click)="INDRA_addTransfer()"
						attr.aria-label="Add transfer for free">
						Add Transfer
					</button>
				</div>
			</div>

			<!-- <div class="col-6 col-p-12 align-right" *ngIf="form.get('vehicle').value">

				<button class="button button-secondary button--icon-right" role="alert" [attr.aria-label]="'extrasSidebar.airportTransfer.aria.transferAdded' | ibeadmin | async">
					{{INDRA_getTransfer().label.split(' ')[0]}}
					<app-svg svg="icons.svg#general--check" aria-hidden="true" [alt]="'extrasSidebar.airportTransfer.alt.checkedIcon' | ibeadmin | async"></app-svg>
				</button>
				<app-svg *ngIf="!isModificationDisallowed && !extra[0]['readOnly']" 
					[title]="'extrasSidebar.airportTransfer.text.removeExtra' | ibeadmin | async" 
					[attr.aria-label]="'extrasSidebar.airportTransfer.aria.removeTransfer' | ibeadmin | async" [ngClass]="['remove-extra']"
					svg="icons.svg#general--close" 
					(click)="INDRA_removeTransfer()" 
					aria-hidden="true" 
					[alt]="'extrasSidebar.airportTransfer.alt.removeIcon' | ibeadmin | async"
					tabindex="0">
				</app-svg>

			</div>

			<div class="col-6 col-p-12 align-right" *ngIf="!isModificationDisallowed && !form.get('vehicle').value">
				<form [formGroup]="form">
					<app-select-input [parentForm]="form" [id]="'vehicle'" formControlName="vehicle"
						[placeholder]="'extrasSidebar.airportTransfer.text.chooseVehicleType' | ibeadmin | async" [inputOptions]="optionsTransfer"></app-select-input>
				</form>
			</div> -->

		</div>

		<hr class="separator" aria-hidden="true">

		<ng-container *ngIf="INDRA_showHandleDone()">
			<!-- <div class="sidebar__totals" *ngIf="form.get('vehicle').value">
				<div class="total">
					<label class="label">{{ 'extrasSidebar.airportTransfer.label.oneItem' | ibeadmin | async }}</label>
					<p class="value">{{ INDRA_printAmount() | indracurrency : currencyCode }}</p>

				</div>

				<p class="muted">
					{{ 'extrasSidebar.airportTransfer.text.discountVoucherFree' | ibeadmin | async }}
				</p>

			</div> -->

			<button class="button full-width button--small" 
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()"
				[attr.aria-label]="'extrasSidebar.airportTransfer.aria.confirmAddedBags' | ibeadmin | async">
				{{ 'extrasSidebar.airportTransfer.text.done' | ibeadmin | async}}
			</button>
		</ng-container>

		<ng-container *ngIf="hasError">
			<div class="container">
				<app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" 
					[title]="'extrasSidebar.airportTransfer.title.internalError' | ibeadmin | async">
					<div message>
						<span>
							{{ 'extrasSidebar.airportTransfer.text.internalOccurred' | ibeadmin | async }}
						</span>
					</div>
				</app-notification>
			</div>
		</ng-container>


		<div class="conditions">
			<h3 class="title-h3 conditions__title">{{ 'extrasSidebar.airportTransfer.label.conditions' | ibeadmin | async }}</h3>
			<div class="conditions__text">
				<div class="grid">
					<div class="col-12">
						<ul class="bullet-list">
							<li>
								{{ 'extrasSidebar.airportTransfer.text.toBenefitFromTheOffer' | ibeadmin | async }}
								<a
									class="link"
									target=”_blank”
									href="{{ 'externalURLs.cityrama' | ibeadmincfg }}"
									[attr.aria-label]="'extrasSidebar.airportTransfer.label.openCityrama' | ibeadmin | async"
								>
									{{ 'extrasSidebar.airportTransfer.text.openCityrama' | ibeadmin | async }}
								</a>
							</li>
							<li>{{ 'extrasSidebar.airportTransfer.text.pricesPresented' | ibeadmin | async }}</li>
							<li>{{ 'extrasSidebar.airportTransfer.text.servicesBetween' | ibeadmin | async }}</li>
							<li>{{ 'extrasSidebar.airportTransfer.text.changesCommunicated' | ibeadmin | async }}</li>
							<li>{{ 'extrasSidebar.airportTransfer.text.tapsPartner' | ibeadmin | async }}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>
